import LayoutModal, { LayoutModalProps } from './layout-modal'

export type { LayoutModalProps }
export default LayoutModal
